import * as React from 'react';
import { Field } from 'redux-form';

import KeyboardArrowDown from 'material-ui/svg-icons/hardware/keyboard-arrow-down';
import {
  FormChipInputRemote,
  default as ChipInputRemoteUas
} from '@inqool/uas-web-core/es/components/controls/ChipinputRemote';

import * as T from '@components/form/RemoteChipInput/_remoteChipInputTypes';
import { compose, mapProps } from 'recompose';

const enhance = compose<T.InnerProps, any>(
  mapProps(({ filterActive, params = { filter: [], sorting: [] }, ...rest }) => ({
    params: {
      ...params,
      pageSize: 9999,
      filter: filterActive
        ? [
            {
              field: 'active',
              operation: 'EQ',
              value: true
            },
            ...params.filter
          ]
        : params.filter,
      sorting: filterActive
        ? [
            {
              sort: 'order',
              order: 'ASC'
            },
            {
              sort: 'name',
              order: 'ASC'
            },
            ...params.sorting
          ]
        : params.sorting
    },
    ...rest
  }))
);

const RemoteChipInput: React.SFC<T.OutterProps & T.InnerProps> = props => (
  <div style={props.style ? props.style : { position: 'relative', marginTop: -10 }}>
    <FormChipInputRemote {...props} />
    <KeyboardArrowDown
      style={{
        color: '#e1e0e1',
        position: 'absolute',
        right: 0,
        top: 26
      }}
    />
  </div>
);

export default enhance(RemoteChipInput);

export const ChipInputRemote = enhance(ChipInputRemoteUas);

export class RemoteChipInputField extends Field<T.OutterCustomProps> {}



// WEBPACK FOOTER //
// ./src/components/form/RemoteChipInput/RemoteChipInput.tsx